import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  TextField,
} from "@mui/material";
import getUserbyRole, { filterDataUserByLevel } from "services/userService";
import PropTypes from "prop-types";
import AutoCompleteComponent from "components/AutoCompleteComponent";
import { roleN5E, roleN5P } from "constant/role";
import handleSelectChange from "helpers/selectHelper";
import getEspece from "services/especeService";
import MDButton from "components/MDButton";
import {
  createDemandeIdentification,
  updateDemandeIdentification,
} from "services/demandeIdentificationService";
import { ERROR } from "constant/message";
import { useNavigate } from "react-router-dom";
import { LAST_PATH } from "constant";
import dataStatutDemandeIdentification from "constant/dataStatutDemandeIdentification";
import userInfos, { isAdminDepartemental, isSuperAdmin } from "utils/userInfos";

import { PATH_USER_N5E } from "constant/moduleInfo";
import AnimalPerson from "./AnimalPerson";

const NewDemandeIdentificationComponent = ({ propsDataConfig }) => {
  const { ApiService, handleLoad, selectedData } = propsDataConfig;
  const navigate = useNavigate();
  const [listUser, setListUser] = useState([]);
  const [listEspece, setListEspece] = useState([]);
  const [demande, setDemande] = useState(selectedData ?? {});
  const [userInfo, setUserInfo] = useState(selectedData?.user ? { info: selectedData?.user } : {});
  const [statut, setStatut] = useState("");
  const isUpdate = Object.keys(selectedData).length !== 0;
  const canAddbyAdminDepartement = isAdminDepartemental();
  const canAddbySuperAdmin = isSuperAdmin();
  const canAdd = canAddbyAdminDepartement || canAddbySuperAdmin;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let updatedDemande = {};
    if (value.isSelect && name !== "status") {
      updatedDemande = handleSelectChange(demande, name, value);
    } else if (name === "status") {
      let statutValue;
      let statusName;
      if (value.reason === "clear") {
        statutValue = "";
        statusName = "";
      } else {
        statutValue =
          dataStatutDemandeIdentification.find((i) => i.name === value.newValue.name)?.label ?? "";
        statusName =
          dataStatutDemandeIdentification.find((i) => i.name === value.newValue.name)?.name ?? "";
      }
      updatedDemande = { ...demande, status: statusName };
      setStatut(statutValue);
    } else {
      updatedDemande = { ...demande, [name]: value };
    }
    setDemande(updatedDemande);
    if (name === "user" && value.reason !== "clear") {
      const selectedUser = {
        info: value.newValue,
      };
      setUserInfo(selectedUser);
    }
  };

  const fetchUser = async () => {
    const listTargetRole = [...roleN5E, ...roleN5P];
    const data = await getUserbyRole(ApiService.getDataUser, listTargetRole);
    let filterUser = data.filter((i) => i.enabled);
    if (isAdminDepartemental()) {
      const userData = userInfos();
      const filterData = await filterDataUserByLevel(filterUser, PATH_USER_N5E);

      filterUser = filterData.filter(
        (i) => i.enabled && i.lieu.departement === userData.lieu.departement
      );
    }
    if (isUpdate) {
      const updatedDemande = demande;
      updatedDemande.user.label = `${demande.user.prenom} ${demande.user.nom}`;
      setDemande(updatedDemande);
    }
    setListUser(filterUser);
  };
  const fetchEspece = async () => {
    const data = await getEspece(ApiService.getData);
    const resultEspece = data.map((i) => {
      let count = 0;
      let idEffectif = 0;
      if (isUpdate) {
        count =
          selectedData?.effectifs.find((x) => i.nomCourant === x.espece.nomCourant)?.count ?? 0;
        idEffectif =
          selectedData?.effectifs.find((x) => i.nomCourant === x.espece.nomCourant)?.id ?? 0;
      }
      return {
        espece: i,
        count,
        id: idEffectif,
      };
    });
    setListEspece(resultEspece);
    //
  };
  useEffect(() => {
    fetchUser();
    fetchEspece();
    if (isUpdate) {
      const statutValue =
        dataStatutDemandeIdentification.find((i) => i.name === selectedData?.status)?.label ?? "";
      setStatut(statutValue);
    }
  }, []);
  const checkForm = async (EspeceEffectif) => {
    if (demande.user) {
      let result;
      const data = [
        {
          status: demande.status ?? "INITIALIZED",
          id: demande?.id,
          user: demande?.user,
          effectifs: EspeceEffectif,
        },
      ];
      if (isUpdate) {
        result = await updateDemandeIdentification(ApiService.putData, data);
      } else {
        result = await createDemandeIdentification(ApiService.postData, data);
      }
      if (result !== ERROR) {
        const loadData = {
          isAlert: true,
          message: "Opération effectuée avec succès",
          isLoading: false,
          alertSeverity: "success",
        };
        handleLoad(loadData);
        setTimeout(() => {
          const lastPath = localStorage.getItem(LAST_PATH);
          navigate(lastPath);
        }, 200);
      }
    } else {
      const loadData = {
        isAlert: true,
        message: "Veuillez sélectionner un Demandeur",
        isLoading: false,
        alertSeverity: "error",
      };
      handleLoad(loadData);
    }
  };
  return (
    <Box
      sx={{ padding: 2, border: "1px solid #ccc", borderRadius: 2, margin: 2 }}
      style={{ backgroundColor: "white" }}
    >
      <Box textAlign="center">
        <Typography variant="h6">Informations de la Demande d&apos;identification</Typography>
      </Box>
      {listUser && canAdd && (
        <AutoCompleteComponent
          options={listUser}
          name="user"
          label="Eleveur / Propriétaire"
          value={demande?.user ?? ""}
          onChange={handleInputChange}
          isResultObject
        />
      )}
      {demande.user && <AnimalPerson person={userInfo} />}
      {listEspece.length > 0 && (
        <>
          <Box textAlign="center">
            <Typography variant="h6">Effectifs par espèces</Typography>
          </Box>

          <EspeceCount
            list={listEspece}
            handleLoad={handleLoad}
            checkForm={checkForm}
            handleInputChange={handleInputChange}
            selectedData={selectedData}
            isUpdate={isUpdate}
            statut={statut}
            canAdd={canAdd}
          />
        </>
      )}
    </Box>
  );
};
const EspeceCount = ({
  list,
  handleLoad,
  checkForm,
  handleInputChange,
  isUpdate,
  statut,
  canAdd,
}) => {
  const [rows, setRows] = useState(list);
  const handleEffectifChange = (index, value) => {
    const updatedRows = [...rows];
    updatedRows[index].count = parseInt(value, 10) || 0;
    setRows(updatedRows);
  };

  const handleSubmit = () => {
    const effectifTotal = rows.reduce((total, espece) => total + espece.count, 0);
    if (effectifTotal === 0) {
      const loadData = {
        isAlert: true,
        message: "Veuillez saisir un effectif",
        isLoading: false,
        alertSeverity: "error",
      };
      handleLoad(loadData);
    } else if (isUpdate && statut === "") {
      const loadData = {
        isAlert: true,
        message: "Veuillez sélectionner un statut",
        isLoading: false,
        alertSeverity: "error",
      };
      handleLoad(loadData);
    } else {
      const especeEffectif = rows.map((i) => ({
        espece: i.espece,
        count: i.count,
        id: i.id,
      }));
      checkForm(especeEffectif);
    }
  };

  return (
    <TableContainer component={Paper} style={{ width: "100%" }}>
      <Table style={{ width: "100%" }}>
        <TableBody>
          {rows?.map((row, index) => (
            <TableRow key={row.espece?.label}>
              <TableCell component="th" scope="row" style={{ width: "70%" }}>
                {row.espece?.label}
              </TableCell>
              <TableCell align="right" style={{ width: "30%" }}>
                <TextField
                  type="number"
                  value={row.count}
                  onChange={(e) => handleEffectifChange(index, e.target.value)}
                  variant="outlined"
                  size="small"
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {dataStatutDemandeIdentification && isUpdate && (
        <AutoCompleteComponent
          options={dataStatutDemandeIdentification}
          name="status"
          label="statut"
          value={statut ?? ""}
          onChange={handleInputChange}
          isDisabled={!canAdd}
          isResultObject={false}
        />
      )}
      {canAdd && (
        <Box display="flex" alignItems="center" justifyContent="center">
          <MDButton type="submit" variant="gradient" color="info" onClick={handleSubmit}>
            {isUpdate ? "Modifier" : "Enregistrer"}
          </MDButton>
        </Box>
      )}
    </TableContainer>
  );
};

export default NewDemandeIdentificationComponent;
NewDemandeIdentificationComponent.propTypes = {
  propsDataConfig: PropTypes.object.isRequired,
};

EspeceCount.defaultProps = {
  statut: "",
};
EspeceCount.propTypes = {
  list: PropTypes.object.isRequired,
  handleLoad: PropTypes.func.isRequired,
  checkForm: PropTypes.func.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  isUpdate: PropTypes.bool.isRequired,
  canAdd: PropTypes.bool.isRequired,
  statut: PropTypes.string,
};
